import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/images/report/default_avatar.png'
import _imports_1 from '../assets/images/report/star_min.png'
import _imports_2 from '../assets/images/report/star_min_gray.png'
import _imports_3 from '../assets/images/report/star_max.png'
import _imports_4 from '../assets/images/report/quotation.png'
import _imports_5 from '../assets/images/report/ibook_logo.png'
import _imports_6 from '../assets/images/report/bottom_qrcode.png'
import _imports_7 from '../assets/images/loading.png'


const _hoisted_1 = { class: "base-info" }
const _hoisted_2 = { class: "avatar-con" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  class: "avatar"
}
const _hoisted_5 = { class: "date" }
const _hoisted_6 = { class: "satr-con" }
const _hoisted_7 = { class: "star-box" }
const _hoisted_8 = { class: "star-min" }
const _hoisted_9 = {
  key: 0,
  src: _imports_1
}
const _hoisted_10 = {
  key: 1,
  src: _imports_2
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "star-min" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "star-max"
  })
], -1)
const _hoisted_12 = { class: "star-min" }
const _hoisted_13 = {
  key: 0,
  src: _imports_1
}
const _hoisted_14 = {
  key: 1,
  src: _imports_2
}
const _hoisted_15 = { class: "percent-con" }
const _hoisted_16 = { class: "percent" }
const _hoisted_17 = { class: "txt" }
const _hoisted_18 = {
  key: 0,
  class: "study-con"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", { class: "item-title study-con-title" }, "本周学习内容", -1)
const _hoisted_20 = { class: "study-tags" }
const _hoisted_21 = { class: "study-data" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", { class: "item-title study-data-title" }, "本周学习数据", -1)
const _hoisted_23 = { class: "histogram-box" }
const _hoisted_24 = { class: "data-item" }
const _hoisted_25 = { class: "data-item" }
const _hoisted_26 = { class: "data-item" }
const _hoisted_27 = {
  key: 0,
  class: "data-tips"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "histogram-main",
  id: "histogramMain"
}, null, -1)
const _hoisted_29 = { class: "encourage-con" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "quotation"
}, null, -1)
const _hoisted_31 = { class: "encourage-txt" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "bottom-logo"
}, null, -1)
const _hoisted_33 = {
  key: 1,
  src: _imports_6,
  class: "fixed-qrcode"
}
const _hoisted_34 = {
  key: 1,
  class: "my-loading"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, "内容加载中…", -1)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["report-container", {'show-qrcode': !_ctx.isIbookApp}])
  }, [
    (_ctx.reportInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.reportInfo.basic_info.icon)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.reportInfo.basic_info.icon,
                    class: "avatar"
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("img", _hoisted_4)),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.startDate) + " - " + _toDisplayString(_ctx.endDate), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.reportInfo.basic_info.level > 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                    : (_openBlock(), _createElementBlock("img", _hoisted_10))
                ]),
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.reportInfo.basic_info.level > 2)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                    : (_openBlock(), _createElementBlock("img", _hoisted_14))
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, [
                  _createTextVNode("超越了全国"),
                  _createElementVNode("span", null, _toDisplayString(_ctx.reportInfo.basic_info.rate) + "%", 1),
                  _createTextVNode("的用户")
                ]),
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.encouragements[_ctx.reportInfo.basic_info.level]), 1)
              ])
            ])
          ]),
          (_ctx.reportInfo.content && _ctx.reportInfo.content.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportInfo.content, (con, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tag-item",
                      key: index
                    }, _toDisplayString(con), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, [
                _createTextVNode("本周学习"),
                _createElementVNode("span", null, _toDisplayString(_ctx.reportInfo.data.week_days), 1),
                _createTextVNode("天，累计学习"),
                _createElementVNode("span", null, _toDisplayString(_ctx.reportInfo.data.total_days), 1),
                _createTextVNode("天")
              ]),
              _createElementVNode("p", _hoisted_25, [
                _createTextVNode("本周观看视频"),
                _createElementVNode("span", null, _toDisplayString(_ctx.weekStudyVideo), 1),
                _createTextVNode("分钟，累计观看"),
                _createElementVNode("span", null, _toDisplayString(_ctx.allStudyVideo), 1),
                _createTextVNode("分钟")
              ]),
              _createElementVNode("p", _hoisted_26, [
                _createTextVNode("本周共批改"),
                _createElementVNode("span", null, _toDisplayString(_ctx.reportInfo.data.week_correct_ques_num), 1),
                _createTextVNode("题")
              ]),
              (_ctx.reportInfo.data.week_correct_ques_num < 7)
                ? (_openBlock(), _createElementBlock("p", _hoisted_27, "本周答题数量较少，为更好地记录学习数据，可以多使用拍照批改功能哦！"))
                : _createCommentVNode("", true),
              _hoisted_28
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.reportInfo.doc), 1)
          ]),
          _hoisted_32,
          (!_ctx.isIbookApp)
            ? (_openBlock(), _createElementBlock("img", _hoisted_33))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37))
      : _createCommentVNode("", true)
  ], 2))
}